import { get } from "@utils/axios";

export const getNavigationReq = () => {
    return get("navigations");
}

export const getMyPermissionsReq = () => {
    return get("my-permissions");
}
